

export const ROUTER_PATHS = {
  home: '/',
  login: '/auth/login',

  /////* Perfil ----------------
  perfil: {
    root: 'perfil',
    general: 'general',
    seguridad: 'seguridad'
  },
  /////*
  solicitud_preventa: {
    root: 'solicitud',

    solicitudCrear: 'solicitud/crear',
    solicitudNav: '/solicitud',
    solicitudVerificarsolicitud: 'solicitud/solicitud-verificacion',
    solicitudCrearComentario: 'solicitud/crear-comentario/:id',
  },
  control_cambios: {
    root: 'controlcambios',

    cambioService: 'control-cambios',
    cambioServiceCrear: 'control-cambios/crear',
    cambioServiceEditar: 'control-cambios/editar/:id',
    cambioServicenav: '/controlcambios/control-cambios',
    cambioServiceVer: 'control-cambios/ver/:id',
    cambioServiceVerNav: '/controlcambios/control-cambios/ver/:id',

    cambioServiceMisAprobaciones: 'mis-aprobaciones',
    cambioServiceMisAprobacionesNav: '/controlcambios/mis-aprobaciones',

    misCambios: 'mis-cambios',
    misCambiosNav: '/controlcambios/mis-cambios',

    /**Areas control de cambios */
    area: 'area',
    areaCrear: 'area/crear',
    areaEditar: 'area/editar/:id',
    areaNav: '/controlcambios/area',
    /***Aprobadores de control de cambios */
    aprobador: 'aprobador',
    aprobadorarea: 'aprobadorarea',
    aprobadorareanav: '/controlcambios/aprobador',
    aprobadorareaanva: '/controlcambios/aprobadorarea',

    /***Notificaciones de control de cambios */
    notificacion: 'notificacion',
    notificacionCrear: 'notificacion/crear',
    notificacionEditar: 'notificacion/editar/:id',
    notificacionNav: '/controlcambios/notificacion',

    /***Responsables de control de cambios */
    responsable: 'responsable',
    responsableCrear: 'responsable/crear',
    responsableEditar: 'responsable/editar/:id',
    responsableNav: '/controlcambios/responsable',
    /***Servidores de control de cambios */
    servidor: 'servidor',
    servidorCrear: 'servidor/crear',
    servidorEditar: 'servidor/editar/:id',
    servidorNav: '/controlcambios/servidor',
    /***Tipos de riesgo de control de cambios */
    tipoRiesgo: 'tipo-riesgo',
    tipoRiesgoCrear: 'tipo-riesgo/crear',
    tipoRiesgoEditar: 'tipo-riesgo/editar/:id',
    tipoRiesgoNav: '/controlcambios/tipo-riesgo',
    /***Tipos de accion de control de cambios */
    tipoAccion: 'tipo-accion',
    tipoAccionCrear: 'tipo-accion/crear',
    tipoAccionEditar: 'tipo-accion/editar/:id',
    tipoAccionNav: '/controlcambios/tipo-accion',

    /***Tipos de metrica de control de cambios */
    tipoMetrica: 'tipo-metrica',
    tipoMetricaCrear: 'tipo-metrica/crear',
    tipoMetricaEditar: 'tipo-metrica/editar/:id',
    tipoMetricaNav: '/controlcambios/tipo-metrica',

  },
  /////* Administración ----------------
  administration: {
    root: 'parametrizacion',

    ///* Rad Check ------ 
    radCheck: 'rad-check',
    radCheckCrear: 'rad-check/crear',
    radCheckEditar: 'rad-check/editar/:id',
    radCheckNav: '/parametrizacion/rad-check',

    ///* IVA ------ | OK
    iva: 'iva',
    ivaCrear: 'iva/crear',
    ivaEditar: 'iva/editar/:id',
    ivaNav: '/parametrizacion/iva',

    ///* Observaciones----- | OK
    observacion: 'observacion',
    observacionCrear: 'observacion/crear',
    observacionEditar: 'observacion/editar/:id',
    observacionNav: '/parametrizacion/observacion',
    ///* Responsable 
    responsable: 'responsable',
    responsableCrear: 'responsable/crear',
    responsableEditar: 'responsable/editar/:id',
    responsableNav: '/parametrizacion/responsable',

    ///* Empresa ------
    empresa: 'empresas',
    empresaCrear: 'empresas/crear',
    empresaEditar: 'empresas/editar/:id',
    empresaNav: '/parametrizacion/empresas',

    ///* Método de Pago ------
    metodoPago: 'metodo-pago',
    metodoPagoCrear: 'metodo-pago/crear',
    metodoPagoEditar: 'metodo-pago/editar/:id',
    metodoPagoNav: '/parametrizacion/metodo-pago',
    ///* Método de Pago V2 (3 niveles) ------
    metodoPagoV2Crear: 'metodo-pago/v2/crear',
    metodoPagoV2Editar: 'metodo-pago/v2/editar/:id',
    ///* Método de Pago proveedor ------
    metodoPagoProveedor: 'metodo-pago-proveeedor',
    metodoPagoProveedorCrear: 'metodo-pago-proveeedor/crear',
    metodoPagoProveedorEditar: 'metodo-pago-proveeedor/editar/:id',
    metodoPagoProveedorNav: '/parametrizacion/metodo-pago-proveeedor',

    ///* Canal de Venta ------ TODO:s
    canalVenta: 'canal-venta',
    canalVentaCrear: 'canal-venta/crear',
    canalVentaEditar: 'canal-venta/editar/:id',
    canalVentaNav: '/parametrizacion/canal-venta',

    ///* Promociones ------
    promociones: 'promociones',
    promocionesCrear: 'promociones/crear',
    promocionesEditar: 'promociones/editar/:id',
    promocionesNav: '/parametrizacion/promociones',

    ///* Tipo COMPROBANTE ------ TODO:
    tiposDocumento: 'tipo-documento',
    tiposDocumentoCrear: 'tipo-documento/crear',
    tiposDocumentoEditar: 'tipo-documento/editar/:id',
    tiposDocumentoNav: '/parametrizacion/tipo-documento',

    // ///* Recurrencia ------ | -- CHOICE
    // recurrencia: 'recurrencia',
    // recurrenciaCrear: 'recurrencia/crear',
    // recurrenciaEditar: 'recurrencia/editar/:id',
    // recurrenciaNav: '/parametrizacion/recurrencia',

    ///* Paises ------ | OK
    paises: 'paises',
    paisesCrear: 'paises/crear',
    paisesEditar: 'paises/editar/:id',
    paisesNav: '/parametrizacion/paises',

    ///* Provincias ------ | OK
    provincias: 'provincias',
    provinciasCrear: 'provincias/crear',
    provinciasEditar: 'provincias/editar/:id',
    provinciasNav: '/parametrizacion/provincias',
    provinciasEditarNav: '/parametrizacion/provincias/editar',

    ///* Ciudades ------ | OK
    ciudades: 'ciudades',
    ciudadesCrear: 'ciudades/crear',
    ciudadesEditar: 'ciudades/editar/:id',
    ciudadesNav: '/parametrizacion/ciudades',
    ciudadesEditarNav: '/parametrizacion/ciudades/editar',

    ///* Tipo Instalación ------ | OK
    tiposInstalacion: 'tipo-instalacion',
    tiposInstalacionCrear: 'tipo-instalacion/crear',
    tiposInstalacionEditar: 'tipo-instalacion/editar/:id',
    tiposInstalacionNav: '/parametrizacion/tipo-instalacion',

    ///* Tipo Comprobante ------
    tipoComprobante: 'tipos-comprobante',
    tipoComprobanteCrear: 'tipos-comprobante/crear',
    tipoComprobanteEditar: 'tipos-comprobante/editar/:id',
    tipoComprobanteNav: '/parametrizacion/tipos-comprobante',

    ///* Codigos OTP ------
    codigosOTP: 'codigos-otp',
    codigosOTPNav: '/parametrizacion/codigos-otp',

    // ====================================

    ///* Usuarios ------ | OK
    usuarios: 'usuarios',
    usuariosCrear: 'usuarios/crear',
    usuariosEditar: 'usuarios/editar/:id',
    usuariosNav: '/parametrizacion/usuarios',

    ///* MFA Admin ------
    mfaAdmin: 'mfa-admin',
    mfaAdminNav: '/parametrizacion/mfa-admin',

    ///* Grupos sistemas ------ | OK
    grupoSistema: 'grupos-sistema',
    grupoSistemaCrear: 'grupos-sistema/crear',
    grupoSistemaEditar: 'grupos-sistema/editar/:id',
    grupoSistemaNav: '/parametrizacion/grupos-sistema',

    ///* Reporte de usuarios (dashboard consolidado) ------
    reporteUsuarios: 'reporte-usuarios',
    reporteUsuariosNav: '/parametrizacion/reporte-usuarios',

    systemParameters: 'parametros-sistema',
    systemParametersCrear: 'parametros-sistema/crear',
    systemParametersEditar: 'parametros-sistema/editar/:id',
    systemParametersNav: '/parametrizacion/parametros-sistema',

    //centro costos
    centroCosto: 'centro-costo',
    centroCostoCrear: 'centro-costo/crear',
    centroCostoEditar: 'centro-costo/editar/:id',
    centroCostoNav: '/parametrizacion/centro-costo',
    //Areas
    area: 'areas',
    areaCrear: 'areas/crear',
    areaEditar: 'areas/editar/:id',
    areaNav: '/parametrizacion/areas',
    //ice
    ICE: 'ice',
    ICECrear: 'ice/crear',
    ICEEditar: 'ice/editar/:id',
    ICENav: '/parametrizacion/ice',
    tipoRegimenes: 'tipo-regimenes',
    tipoRegimenesCrear: 'tipo-regimenes/crear',
    tipoRegimenesEditar: 'tipo-regimenes/editar/:id',
    tipoRegimenesNav: '/parametrizacion/tipo-regimenes',

    //recepcion-equipos catalogos
    recepcionEquiposCatalogos: 'recepcion-equipos-catalogos',
    recepcionEquiposCatalogosNav: '/parametrizacion/recepcion-equipos-catalogos',

    //departamentos
    departamento: 'departamentos',
    departamento_crear: 'departamentos/crear',
    departamento_editar: 'departamentos/editar/:id',
    departamento_nav: '/parametrizacion/departamentos',
    //entidades-financieras
    entidadesFinancieras: 'entidades-financieras',
    entidadesFinancieras_crear: 'entidades-financieras/crear',
    entidadesFinancieras_editar: 'entidades-financieras/editar/:id',
    entidadesFinancieras_nav: '/parametrizacion/entidades-financieras',

    //cooperativa
    cooperativa: 'cooperativa',
    cooperativa_crear: '/parametrizacion/cooperativa/crear',
    cooperativa_editar: '/parametrizacion/cooperativa/editar/:id',
    cooperativa_nav: '/parametrizacion/cooperativa',


    //comisiones
    configuracion_comiciones: 'comicion-configuracion',
    configuracion_comiciones_crear: 'comicion-configuracion/crear',
    configuracion_comiciones_editar: 'comicion-configuracion/editar/:id',
    configuracion_comiciones_nav: '/parametrizacion/comicion-configuracion',
    //porcentaje ret iva servicios
    porcentajes_ret_iva_servicios: 'porcentajes-ret-iva-servicios',
    porcentajes_ret_iva_servicios_crear: 'porcentajes-ret-iva-servicios/crear',
    porcentajes_ret_iva_servicios_editar:
      'porcentajes-ret-iva-servicios/editar/:id',
    porcentajes_ret_iva_servicios_nav:
      '/parametrizacion/porcentajes-ret-iva-servicios',
    //porcentaje ret iva bienes
    porcentajes_ret_iva_bienes: 'porcentajes-ret-iva-bienes',
    porcentajes_ret_iva_bienes_crear: 'porcentajes-ret-iva-bienes/crear',
    porcentajes_ret_iva_bienes_editar: 'porcentajes-ret-iva-bienes/editar/:id',
    porcentajes_ret_iva_bienes_nav:
      '/parametrizacion/porcentajes-ret-iva-bienes',
    //tarjetas
    tarjetas: 'tarjetas',
    tarjetas_crear: 'tarjetas/crear',
    tarjetas_editar: 'tarjetas/editar/:id',
    tarjetas_nav: '/parametrizacion/tarjetas',
    //motivos
    motivos: 'motivos',
    motivos_crear: 'motivos/crear',
    motivos_editar: 'motivos/editar/:id',
    motivos_nav: '/parametrizacion/motivos',
    //motivos
    motivos_rechazo: 'motivo-rechazo',
    motivos_rechazo_crear: 'motivo-rechazo/crear',
    motivos_rechazo_editar: 'motivo-rechazo/editar/:id',
    motivos_rechazo_nav: '/parametrizacion/motivo-rechazo',
    //unidades-transporte
    unidades_transporte: 'unidades-transporte',
    unidades_transporte_crear: 'unidades-transporte/crear',
    unidades_transporte_editar: 'unidades-transporte/editar/:id',
    unidades_transporte_nav: '/parametrizacion/unidades-transporte',
    //tipos-documentos

    //arhivos
    cargar_documentacion_nav: '/parametrizacion/cargar-documentos/',

    ///* Auditoría ------
    auditoria: 'auditoria',
    auditoriaNav: '/parametrizacion/auditoria',

    ///* Gestion de Accesos (Permisos, Roles, Usuarios) - Genérico
    gestionAccesos: 'gestion-accesos',
    gestionAccesosNav: '/parametrizacion/gestion-accesos',

    ///* Rotacion de roles por area (calendario semanal)
    rotacionRoles: 'rotacion-roles',
    rotacionRolesNav: '/parametrizacion/rotacion-roles',
  },
  noc: {
    root: 'noc',
    solicitudVentaCorporativoNav: '/noc/solicitud-venta',
    //agendamientoNocNav: '/noc/agendamiento',
    agendamientoNocNav: '/noc/agendacorporativa',
    factibilidadCorporativoNav: '/noc/factibilidad-corporativo',
    factibilidadCorporativoAprobarNav: '/noc/factibilidad-corporativo/aprobar',
    inspeccionCorporativoNav: '/noc/inspeccion/factibilidad-corporativo',

    factibilidadCorporativoAprobar: '/noc/factibilidad-corporativo/aprobar/:idpreventacorporativa',
    factibilidadCorporativoNavCrear: '/noc/factibilidad-corporativo/:idpreventacorporativa',
    inspeccionCorporativoNavRevisar: '/noc/inspeccion/factibilidad-corporativo/:idfactibilidadcorporativa',
    //factibilidadCorporativoNavUpdate: '/noc/factibilidad-corporativo/:idfactibilidadcorporativa',

    createAgendamientoNoc: '/noc/agendamiento/crear/:idFactibilidad',
    createAgendamientoNocNav: '/noc/agendamiento/crear',
    factibilidadCorporativoNavUpdate: '/noc/factibilidad-corporativo/revision/:idfactibilidadcorporativa',

    preFactibilidadCorporativoView: '/noc/pre-factibilidad-corporativo/visualizar/:idpreventacorporativa',
    factibilidadCorporativoView: '/noc/factibilidad-corporativo/visualizar/:idfactibilidadcorporativa',

    reasignarAgendaCorp: '/noc/agenda/reasignar/:idagenda',
    reasignarAgendaCorpNav: '/noc/agenda/reasignar',

    ///* Trazabilidad Factibilidad Corporativa
    trazabilidadFactibilidadCorporativo: '/noc/factibilidad-corporativo/trazabilidad/:idfactibilidadcorporativa',
    trazabilidadFactibilidadCorporativoNav: '/noc/factibilidad-corporativo/trazabilidad',

    ///* solicitud tecnico
    solicitudTecnicoNocNav: '/noc/solicitud/tecnico',
    solicitudTecnicoNocEditarNav: '/noc/solicitud/tecnico/editar',
    solicitudTecnicoNocEditar: '/noc/solicitud/tecnico/editar/:id',
    solicitudTecnicoNocAgendaEditar: '/noc/solicitud/agenda/tecnico/editar/:id',
    solicitudTecnicoNocAgendaEditarNav: '/noc/solicitud/agenda/tecnico/editar',
    ///* ordenes de trabajo
    ordenesDeTrabajoNocNav: '/noc/ordenes-trabajo-noc',
    ordenesDeTrabajoNocListaNav: '/noc/ordenes-trabajo-noc/lista',
    ordenesDeTrabajoNocCrearNav: '/noc/ordenes-trabajo-noc/crear',
    ordenesDeTrabajoNocEditarNav: '/noc/ordenes-trabajo-noc/editar/:id',
    ordenesDeTrabajoNocVerNav: '/noc/ordenes-trabajo-noc/ver/:id',
    ordenesDeTrabajoNocInformeNav: '/noc/ordenes-trabajo-noc/informe/:id',
    ordenesDeTrabajoNocParametrosNav: '/noc/ordenes-trabajo-noc/parametros',
    ordenesDeTrabajoNocParametrosTipoActividad: '/noc/ordenes-trabajo-noc/parametros/tipo-actividad',
    ordenesDeTrabajoNocParametrosTipoActividadCrearNav: '/noc/ordenes-trabajo-noc/parametros/tipo-actividad/crear',
    ordenesDeTrabajoNocParametrosTipoActividadEditarNav: '/noc/ordenes-trabajo-noc/parametros/tipo-actividad/editar/:id',
    ordenesDeTrabajoNocParametrosIncidenciaCrearNav: '/noc/ordenes-trabajo-noc/parametros/incidencia/crear',
    ordenesDeTrabajoNocParametrosIncidenciaEditarNav: '/noc/ordenes-trabajo-noc/parametros/incidencia/editar/:id',

  },
  ///* Soporte Corporativo
  soporteCorporativo: {
    root: 'soporte-corporativo',

    ///* Gestión de Tickets
    gestionTickets: 'gestion-tickets',
    gestionTicketsNav: '/soporte-corporativo/gestion-tickets',
    gestionTicketsCrear: '/soporte-corporativo/gestion-tickets/crear',
    gestionTicketsEditar: '/soporte-corporativo/gestion-tickets/editar/:id',
    gestionTicketsEditarNav: '/soporte-corporativo/gestion-tickets/editar',
  },
  /////* Ventas ----------------
  ventas: {
    root: 'ventas',

    ///* Prospectos ------
    prospecto: 'prospectos',
    prospectoCrear: '/ventas/prospectos/crear',
    prospectoNav: '/ventas/prospectos',
    ///* Preventas ------
    preventas: 'preventas',
    preventasNav: '/ventas/preventas',
    preventasCrear: '/ventas/preventas/crear/:idprospecto',
    preventasEdit: '/ventas/preventas/editar/:idpreventa/:idprospecto',
    preventasCrearNav: '/ventas/preventas/crear',
    preventasEditNav: '/ventas/preventas/editar/',

    ///*
    preRechazadosVentasNav: '/ventas/pre-rechazados/rechazado/',

    solicitudIngresoProspectoNav: '/ventas/solicitud-ingreso-prospecto/',
    ///* PreAgendamitos ------
    agendamientos: 'agendamientos',
    preAgendamientoNav: '/ventas/agendamientos/',
    agendamientoCrear: '/ventas/agendamientos/crear/:id/',
    preagendamientoCrearNav: '/ventas/agendamientos/crear/',

    agendamientoAgendadoNav: '/ventas/agendado',
    agendamientoFinalizadoAgendadoNav: '/ventas/agendadas-finalizadas',
    agendamientoPendienteActualizacionNav: '/ventas/pendiente-actualizacion',
    agendamientoReporteNav: '/ventas/reporte/agendamiento',

    agendamientoChatNav: '/ventas/agendamiento/chat/',
    agendamientoChat: '/ventas/agendamiento/chat/:idagendamiento/:idenficacion/:canal_venta_create/:razon_social/',


    ///* Agendamiento Actualizar ------
    agendamientoActualizarDoc:
      '/ventas/agendamiento/actualizar-documento/:id_preagendamiento/',
    agendamientoActualizarDocNav: '/ventas/agendamiento/actualizar-documento/',
    agendamientoActualizarInfo:
      '/ventas/agendamiento/actualizar-informacion/:id_preagendamiento/',
    agendamientoActualizarInfoNav:
      '/ventas/agendamiento/actualizar-informacion/',

    ///* Instalacion ------
    instalacionAsignadoNav: '/ventas/instalacion/asignada',
    instalacionRealizadoNav: '/ventas/instalacion/realizada',
    instalacionRechazadoNav: '/ventas/instalacion/rechazada',

    ///* Carga Comprobantes ------
    cargaComprobantes: 'carga-comprobantes',

    ///* Comisiones ------
    comisiones: 'comisiones',

    ///* Clientes Referidos
    referidosNav: '/ventas/referidos',

    ///
    bitacoraVentasNav: '/ventas/bitacora',

    ///* Auditoría
    auditoriaVentasNav: '/ventas/auditoria'
  },

  ///* ventas pymes
  ventasPymes: {
    root: 'venta/pymes',
    ///* prospecto
    prospectoNav: '/venta/pymes/prospecto',
    prospectoCreateNav: '/venta/pymes/prospecto/crear',

    ///* preventa
    preventaNav: '/venta/pymes/preventa',
    preventaCreateNav: '/venta/pymes/preventa/crear',
    preventaCreate: '/venta/pymes/preventa/crear/:id',
    preventaProspectoCreate: '/venta/pymes/preventa/prospecto/crear/',

    ///* preagendamiento
    preagendamientoNav: '/venta/pymes/preagendamiento',
    preagendamientoCreateNav: '/venta/pymes/preagendamiento/crear',
    preagendamientoCreate: '/venta/pymes/preagendamiento/crear/:id/:uid',

    ///* agendamiento
    agendamientoNav: '/venta/pymes/agendamiento',

    ///* gestor de venta pymes
    gestorVenta: '/venta/pymes/gestor-venta/'
  },

  ///* soporte pymes
  soportePymes: {

    root: 'soporte/pymes',

    ///* preagendamiento
    preagendamientoNav: '/soporte/pymes/preagendamiento',
    preagendamientoCreateNav: '/soporte/pymes/preagendamiento/crear',
    preagendamientoCreate: '/soporte/pymes/preagendamiento/crear/:id',

    ///*
    agendamientoEditNav: '/soporte/pymes/agendamiento/editar',
    agendamientoEdit: '/soporte/pymes/agendamiento/editar/:id'

  },
  ///* ventas corporativas
  ventasCorporativas: {
    root: 'corporativo',
    ///* ventas prospecto corporativo
    prospectoCrearCorporativo: '/corporativo/prospectos/crear',
    prospectoEditarCorporativo: '/corporativo/prospectos/editar/:id',
    prospectoCorporativoNav: '/corporativo/prospectos',

    ///* ventas preventa corporativo
    preventaCorporativoNav: '/corporativo/preventa',
    preventaCorporativoCrearNav: '/corporativo/preventa/crear',
    nPreventaCorporativoCrearNav: '/corporativo/prospecto-preventa/crear',
    preventaCorporativoEditNav: '/corporativo/preventa/editar',
    preventaCorporativoCompletarNav: '/corporativo/preventa/completar',
    preventaCorporativoViewNav: '/corporativo/preventa/ver',
    preventaCorporativoCrear: '/corporativo/preventa/crear/:idprospecto',
    // nPreventaCorporativoCrearNav: '/corporativo/prospecto-preventa/crear',
    preventaCorporativoEdit: '/corporativo/preventa/editar/:idpreventa/:idprospecto',
    preventaCorporativoCompletar: '/corporativo/preventa/completar/:idpreventa/:idprospecto',
    preventaCorporativoView: '/corporativo/preventa/ver/:idpreventa/:idprospecto',
    //  /:idprospecto',

    // Estado Venta
    estadoVentaCorporativoNav: '/corporativo/estado-venta',

    ///* Solucion costeada
    solucionCosteadaCorporativoNav: '/corporativo/solucion-costeada',
    solucionCosteadaCorporativoEdit: '/corporativo/solucion-costeada/:idsolucioncosteada',

    ///* Seguimiento y Coste (unificación de Estado Venta + Solución Costeada)
    seguimientoCosteNav: '/corporativo/seguimiento-coste',

    ///* Solicitudes pendientes
    solicitudesPendientesCorporativoNav: '/corporativo/solicitudes-pendientes',
    solicitudesPendientesCorporativoEdit: '/corporativo/solicitudes-pendientes/:idsolicitudespendientes',

    ///* Planes corporativos
    planCorporativoNav: '/corporativo/planes',
    planCorporativoCrearNav: '/corporativo/planes/crear',
    planCorporativoEditar: '/corporativo/planes/editar/:id',
    planCorporativoEditarNav: '/corporativo/planes/editar',

    ///* Solicitud aprobar capacidad
    solicitudCapacidadNav: '/corporativo/solicitud/capacidad',

    ///* Solicitud nueva linea
    solicitudNuevaLineaNav: '/corporativo/solicitud/linea',

    ///* Gestion oportunidad comercial
    gestionOportunidadComercialNav: '/corporativo/gestion-oportunidad-comercial',
    ///* Oportunidad comercial demo
    oportunidadComercialDemoNav: '/corporativo/oportunidad-comercial-demo',
    oportunidadComercialDemoEdit: '/corporativo/oportunidad-comercial-demo/ver/:idoportunidadcomercialdemo',

    ///* Solicitud nueva linea
    coberturaCorporativaNav: '/corporativo/cobertura-corporativa',

    ///* Cobertura Naps
    coberturaNapsNav: '/corporativo/cobertura-naps',
  },
  /////* Supervisión Ventas ----------------
  supervisionVentas: {
    root: 'supervision-ventas',

    ///* Supervisión Ordenes de Trabajo ------
    supervisionOrdenesTrabajo: 'ordenes-trabajo',
    reporteVentasEva: '/ventas/reporte-ventas-eva',

    ///* Liberación de ventas ------
    liberacionVentas: 'liberacion-ventas',
    liberacionVentasLineaNav: '/ventas/liberacion-linea/',
    liberacionVentaProspectoNav: '/ventas/liberacion-prospecto/',
    solicitudContratoFisicoNav: '/ventas/contrato-fisico/',

    ///* Liberación de contratos-instalacion ------
    liberacionContrato: 'liberacion-ventas',
    liberacionContratoNav: '/ventas/liberacion-contrato/',

    ///* Gestión codigos OTP ------
    gestionCodigosOTP: 'gestion-codigos-otp',

    ///* Solicitud Aprobación codigos OTP ------
    solicitudAprobacionCodigosOTP: 'solicitud-aprobacion-codigo-otp',
    solicitudAprobacionCodigosOTPNav: '/ventas/solicitud-aprobacion-codigo-otp',

    solicitudLiberacionValorInstalacionNav:
      '/ventas/solicitud/liberacion-valores-instalacion/',

    ///* Reporte de venta
    reporteVentaNav: '/reportes/ventas-generales',
    ///* Reporte de vendedores externos / call center
    reporteVendedoresExternosNav: '/reportes/vendedores-externos-callcenter',

    ///* Reporte de Contratos Pendientes
    reporteContratosPendientesNav: '/reportes/contratos-pendientes',

    ///* Reporte de comisiones
    reporteComisionesNav: '/reportes/comisiones',

    ///* Reporte de clientes valores softnet
    reporteClientesValoresSoftnetNav: '/reportes/clientes-valores-softnet',

    ///* Reporte de clientes contratos softnet
    reporteContratosSoftnetNav: '/reportes/contratos-softnet',

    // Reporte de clientes golondrinas
    reporteContratosGolondrinasNav: '/reportes/contratos-golondrinas',

    //* Reporte de equipos sin movimiento
    reporteEquiposSinMovimientoNav: '/reportes/equipos-sin-movimiento',

    ///* Clientes
    clientesServicio: '/ventas/clientes',

    ///* Pasar deuda
    reporteSolicitudPasarDeudaNav: '/ventas/solicitud-deuda/',

    ///* Solicitud extranjero
    solicitudExtranjeroNav: '/ventas/solicitud-extranjero/',

    ///* Solicitud Promo Gremios
    solicitudPromoGremiosNav: '/ventas/solicitud-gremio/',

    ///* Seguimiento de actividades
    seguimientoActividadesNav: '/ventas/seguimiento-actividades',

  },
  /////* Reportes ----------------
  reportes: {
    root: 'reportes',
    // Reporte de actividad de inventario
    reporteActividadInventario: 'actividad-inventario',
    reporteActividadInventarioNav: '/reportes/actividad-inventario',
  },
  /////* Operaciones ----------------
  activaciones: {
    root: 'activaciones',

    ///* Activaciones ------
    activaciones: 'activaciones',
    activacionesInstalacion: 'instalacion',
    activacionesInstalacionNav: '/activaciones/instalacion',
    activacionInstallPending: 'instalacion/pendiente/:id',
    activacionInstallGestionada: 'instalacion/gestionada/:id',

    activacionInstallFotos: 'fotos/instalacion',
    activacionInstallFotosNav: '/activaciones/fotos/instalacion',

    activacionInstallCambioPuerto: 'cambio-puerto/instalacion',
    activacionInstallCambioPuertoNav:
      '/activaciones/activaciones/cambio-puerto/instalacion',
    activacionInstallCambioPuertoPending:
      'cambio-puerto/instalacion/:id',

    activacionPendingRecoordinadaInstallOT:
      'instalacion/pendiente-recoordinada/:id',

    // Activaciones rechazadas técnico
    activacionRechazadasTecnicoNav: '/activaciones/rechazadas-tecnico',
    // puertos disponibles
    activacionCajasPuertosDisponibles: 'cajas-puertos-disponibles',
    activacionCajasPuertosDisponiblesNav: '/activaciones/cajas-puertos-disponibles',
    activacionCajasPuertosDisponiblesRevisar: 'cajas-puertos-disponibles/revisar/:id',

    // Actualización de Servicio a Clientes
    activacionActServicioClientes: 'actualizacion-servicio-clientes',
    activacionActServicioClientesCrear: 'actualizacion-servicio-clientes/crear',
    activacionActServicioClientesNav: '/activaciones/actualizacion-servicio-clientes',
    activacionActServicioClientesActualizar: 'actualizacion-servicio-clientes/actualizar/:id',

    // Actualización de Servicio a Clientes
    activacionRadCheck: 'rad-check',
    activacionRadCheckCrear: 'rad-check/crear',
    activacionRadCheckNav: '/activaciones/rad-check',
    activacionRadCheckActualizar: 'rad-check/actualizar/:id',

    tecnicosInstalacionCorp: 'corporativo/instalacion',
    tecnicosInstalacionCorpNav: '/activaciones/corporativo/instalacion',
    tecnicosInstalacionActivarCorp: 'activar/corporativo/instalacion/:id',
    tecnicosInstalacionActivarCorpNav: '/activaciones/activar/corporativo/instalacion',
    //Visita
    activacionesVisita:'visita',
    activacionesVisitaNav:'/activaciones/visita',
    activacionVisitaPending:'visita/pendiente/:id',
    activacionVisitaGestionada:'visita/gestionada/:id',

    //Traslado
    activacionesTraslado:'traslado',
    activacionesTrasladoNav:'/activaciones/traslado',
    activacionTrasladoPending:'traslado/pendiente/:id',
    activacionTrasladoPendingRecoordinada:'traslado/pendiente-recoordinada/:id',
    activacionTrasladoGestionada:'traslado/gestionada/:id',

    activacionesConsultasNav: '/activaciones/consultas'

  },

  /////* Operaciones ----------------
  operaciones: {
    root: 'operaciones',

    ///* PyL Instalaciones: Agenda/Recoordinacion ------
    agendamientoPyL: 'planeacion/agendamientos',
    agendamientoPyLConfirmar: 'planeacion/agendamientos/confirmar/:id',
    agendamientoRecoordinar: 'planeacion/agendamientos/recoordinar/:id',
    agendamientoReasignar: 'planeacion/agendamientos/reasignar/:id',
    agendamientosRevisarUpdated:
      'planeacion/agendamientos/revisar-actualizadas/:id',
    agendamientoPyLFinalizados: '/operaciones/planeacion/finalizados',
    agendamientoPyLNav: '/operaciones/planeacion/agendamientos',
    agendamientoPyLSeguimientoNav: '/operaciones/planeacion/seguimiento-actividades',
    agendamientoPyLReporte: '/operaciones/planeacion/agendamientos/reporte-agendamiento',

    ///* Traslados PYL
    trasladosPyL: 'traslados',
    trasladosPyLNav: '/operaciones/traslados',
    trasladosAgendamientoPyLNav: '/operaciones/traslados/agendamiento',
    trasladosAgendamientoPyL: '/operaciones/traslados/agendamiento/:id',
    ///* Ordenes de servicio (vista general filtrable)
    ordenesServicioGeneral: 'ordenes-servicio',
    ordenesServicioGeneralNav: '/operaciones/ordenes-servicio',
    //*Visita PYL
    visitasPyl: 'visitas',
    visitasPylNav: '/operaciones/visitas',
    visitasAgendamientoPylNav: '/operaciones/visitas/agendamiento',
    visitasAgendamientoPyl: '/operaciones/visitas/agendamiento/:id',
    ///* Activaciones ------
    activaciones: 'activaciones',
    activacionesInstalacion: 'activaciones/instalacion',
    activacionesInstalacionNav: '/operaciones/activaciones/instalacion',
    activacionInstallPending: 'activaciones/instalacion/pendiente/:id',

    activacionInstallFotos: 'activaciones/fotos/instalacion',
    activacionInstallFotosNav: '/operaciones/activaciones/fotos/instalacion',

    activacionInstallCambioPuerto: 'activaciones/cambio-puerto/instalacion',
    activacionInstallCambioPuertoNav:
      '/operaciones/activaciones/cambio-puerto/instalacion',
    activacionInstallCambioPuertoPending:
      'activaciones/cambio-puerto/instalacion/:id',

    activacionPendingRecoordinadaInstallOT:
      'activaciones/instalacion/pendiente-recoordinada/:id',

    ///* Tecnicos ------
    tecnicos: 'tecnico',
    tecnicosInstalacion: 'tecnico/instalacion',
    tecnicosInstalacionNav: '/operaciones/tecnico/instalacion',
    tecnicoPrerechazada: 'tecnico/instalacion/prerechazadas/:id',

    ///* Tecnicos Corporativos ------
    tecnicosCorp: 'tecnico',
    tecnicosInstalacionCorp: 'tecnico/corporativo/instalacion',
    tecnicosInstalacionCorpNav: '/operaciones/tecnico/corporativo/instalacion',
    tecnicosInstalacionActivarCorp: 'activar/corporativo/instalacion/:id',
    tecnicosInstalacionActivarCorpNav: '/operaciones/activar/corporativo/instalacion',
    tecnicoPrerechazadaCorp: 'tecnico/instalacion/corporativo/prerechazadas/:id',

    ///* Auditoria ------
    auditoria: 'auditoria',
    auditoriaInstalaciones: 'auditoria/instalaciones',
    auditoriaInstalacionesNav: '/operaciones/auditoria/instalaciones',
    auditoriaInstalacionesRealizadas: 'auditoria/instalaciones/realizadas/:id',

    ///* mensajeria
    mensajeriaNav: '/operaciones/mensajeria/',
    mensajeria: 'operaciones/mensajeria/:idagendamiento',

    ///* bitacora
    bitacoraPylNav: '/operaciones/bitacora/',
    InformeInstalacionPylNav: '/operaciones/reporte/agendamiento/',

    ///* rechazadas técnico
    rechazadasTecnicoNav: '/operaciones/rechazadas-tecnico/',

    // Agenda de Flotas
    flotasViewNav: `/operaciones/agenda-flotas`,
    agendaFlota: `agenda-flotas/calendario/:id`,
  },

  /////* Técnico ----------------
  tecnico: {
    root: 'tecnico',

    ///* Ordenes de Trabajo ------
    ordenenTrabajo: 'instalaciones',
    ordenenTrabajoNav: '/tecnico/instalaciones',
    ordenenTrabajoAsignadas: 'instalaciones/asignadas/:id',
    ordenenTrabajoAsignadasNav: '/tecnico/instalaciones/asignadas',
    ordenTrabajoFotos: 'fotos/instalaciones',
    ordenTrabajoFotosNav: '/tecnico/fotos/instalaciones',

    // recoordinacion
    ordenTrabajoAsigRecoordinada: 'instalaciones/asignadas/recoordinada/:id',

    // pendientes actualizar
    ordenTrabajoPendienteActualizar: 'instalaciones/asignadas/pendientes-actualizar/:id',

    // revision realizadas
    ordenTrabajoRevisionRealizadas: 'instalaciones/revision-ordenes-trabajo-realizadas/:id',

    ///* Migraciones ------
    migraciones: 'migraciones',
    migracionesNav: '/tecnico/migraciones',

    ///* Traslados ------
    traslados: 'traslados',
    trasladosNav: '/tecnico/traslados',

    ///* Retiros ------
    retiros: 'retiros',
    retirosNav: '/tecnico/retiros',

    ///* Visitas ------
    visitas: 'visitas',
    visitasNav: '/tecnico/visitas',

    // * trabajos noc
    ordenesNocNav: '/tecnico/ordenes-noc',

    ///* Visitas ------
    detalleMateriales: 'detalle-materiales',
    detalleMaterialesNav: '/tecnico/detalle-materiales',
    //*Servicio corporativo
    servicioCorporativo: 'servicio-corporativo',
    servicioCorporativoNav: '/tecnico/servicio-corporativo',
    ///* Transferencia Material ------
    transferenciaMaterial: 'transferencia-material',
    transferenciaMaterialNav: '/tecnico/transferencia-material',

    ///* Ordenes de Trabajo Corporativo ------
    ordenenTrabajoCorp: 'instalaciones',
    ordenenTrabajoCorpNav: '/tecnico/corporativo/instalaciones',
    ordenenTrabajoAsignadasCorp: 'instalaciones/corporativo/asignadas/:id',
    ordenenTrabajoAsignadasCorpNav: '/tecnico/instalaciones/corporativo/asignadas',
    ordenTrabajoFotosCorp: '/fotos/corporativo/instalaciones',
    ordenTrabajoFotosCorpNav: '/tecnico/fotos/corporativo/instalaciones',

    ///* ATS ------
    ats: 'ats',
    atsNav: '/tecnico/ats/',
    atsIdNav: '/tecnico/ats/:id',
    ///* cuadre
    cuadreNav: '/tecnico/cuadre',
    ///* notificacion inventario
    notificacionInventarioNav: '/tecnico/notificacion-inventario',
    // consultas naps
    consultasNapsNav: '/tecnico/consultas-naps',
  },

  /////* Contabilidad ----------------
  contabilidad: {
    root: 'contabilidad',

    ///* Registro de factura ------
    registroFactura: 'registro-factura',
    registroFacturaNav: '/contabilidad/registro-factura',
    registroFacturaNavCrear: '/contabilidad/registro-factura/crear',

    ///* Clientes Corporativos ------
    clientesCoorporativos: 'clientes-coorporativos',
    clientesCoorporativosNav: '/contabilidad/clientes-coorporativos',
    clientesCoorporativosAccion: '/contabilidad/clientes-coorporativos/:id',

    ///* Revision Voucher ------
    revisionVoucher: 'revision-voucher',
    revisionVoucherNav: '/contabilidad/revision-voucher',
    revisionVoucherAccion: '/contabilidad/accion-voucher/:id_preagendamiento',
    revisionVoucherAccionNav: '/contabilidad/accion-voucher/',
    planCuentaNav: '/contabilidad/plan-cuenta/',

    ///* Gestion Inventario Cuadre
    gestionInventarioCuadre: 'gestion-inventario-cuadre',
    gestionInventarioCuadreNav: '/contabilidad/gestion-inventario-cuadre',
    gestionInventarioCuadreCrear: '/contabilidad/gestion-inventario-cuadre/crear',
    gestionInventarioCuadreEditar: '/contabilidad/gestion-inventario-cuadre/editar/:id',
    
    ///* Reingreso Serie
    reingresoSerie: 'reingreso-serie',
    reingresoSerieNav: '/contabilidad/reingreso-serie',
    reingresoSerieCrear: '/contabilidad/reingreso-serie/crear',
    reingresoSerieEditar: '/contabilidad/reingreso-serie/editar/:id',
  },

  /////* Mantenimiento & Operaciones ----------------
  mantenimientoOperaciones: {
    root: 'mantenimiento-operaciones',

    ///* Zonas ------ | OK
    zonas: 'zonas',
    zonasCrear: 'zonas/crear',
    zonasEditar: 'zonas/editar/:id',
    zonasNav: '/mantenimiento-operaciones/zonas',

    ///* Sectores ------ | OK
    sectores: 'sectores',
    sectoresCrear: 'sectores/crear',
    sectoresEditar: 'sectores/editar/:id',
    sectoresNav: '/mantenimiento-operaciones/sectores',

    ///* Nodos ------
    nodos: 'nodos',
    nodosCrear: 'nodos/crear',
    nodosEditar: 'nodos/editar/:id',
    nodosNav: '/mantenimiento-operaciones/nodos',

    ///* Radio Bases ------
    radioBases: 'radio-bases',
    radioBasesCrear: 'radio-bases/crear',
    radioBasesEditar: 'radio-bases/editar/:id',
    radioBasesNav: '/mantenimiento-operaciones/radio-bases',
    radioBasesEditarNav: '/mantenimiento-operaciones/radio-bases/editar',

    ///* Naps ------
    naps: 'naps',
    napsCrear: 'naps/crear',
    napsEditar: 'naps/editar/:id',
    napsNav: '/mantenimiento-operaciones/naps',
    napsEditarNav: '/mantenimiento-operaciones/naps/editar',

    ///* Cobertura ------
    cobertura: 'cobertura',
    coberturaCrear: 'cobertura/crear',
    coberturaEditar: 'cobertura/editar/:id',
    coberturaNav: '/mantenimiento-operaciones/cobertura',

    ///* Flota ------
    flota: 'flotas',
    flotaCrear: 'flotas/crear',
    flotaEditar: 'flotas/editar/:id',
    flotaNav: '/mantenimiento-operaciones/flotas',

    ///* Planificador ------
    planificador: 'planificador',
    planificadorCrear: 'planificador/crear/:idFlota',
    planificadorHorario: 'planificador/horario/:id_flota',
    planificadorNav: '/mantenimiento-operaciones/planificador',

    ///* Pendiente actualizar operaciones
    pendienteActualizarOperacionesNav: '/mantenimiento-operaciones/pendiente-actualizar',
    rechazadasTecnicoNav: '/mantenimiento-operaciones/rechazadas-tecnico',

    ///* Solicitud tecnico para ventas pymes
    solicitudTecnicoPymesNav: '/mantenimiento-operaciones/solicitud/tecnico',
    solicitudTecnicoPymesEditarNav: '/mantenimiento-operaciones/solicitud/tecnico/editar',
    solicitudTecnicoPymesEditar: '/mantenimiento-operaciones/solicitud/tecnico/editar/:id',
    solicitudTecnicoPymesAgendaEditarNav: '/mantenimiento-operaciones/solicitud/tecnico/agenda/editar',
    solicitudTecnicoPymesAgendaEditar: '/mantenimiento-operaciones/solicitud/tecnico/agenda/editar/:id',

    ///* Instalaciones tecnicos
    instalacionesTecnicosNav: '/mantenimiento-operaciones/instalaciones-tecnicos',
    instalacionesTecnicos: '/mantenimiento-operaciones/instalaciones-tecnicos/:id',
  },

  /////* Servicio Internet ----------------
  servicioInternet: {
    root: 'servicio-internet',

    ///* Planes ------
    planes: 'planes',
    planesCrear: 'planes/crear',
    planesEditar: 'planes/editar/:id',
    planesNav: '/servicio-internet/planes',
    planesEditarNav: '/servicio-internet/planes/editar',

    ///* Tipo Plan ------ || CHOICE
    // tipoPlan: 'tipo-plan',
    // tipoPlanCrear: 'tipo-plan/crear',
    // tipoPlanEditar: 'tipo-plan/editar/:id',
    // tipoPlanNav: '/servicio-internet/tipo-plan',
    // tipoPlanEditarNav: '/servicio-internet/tipo-plan/editar',
  },

  /////* Configuración Red ----------------
  configuracionRED: {
    root: 'configuracion-red',

    ///* Grupos IPV4 ------
    grupoIpv4: 'grupo-ipv4',
    grupoIpv4Crear: 'grupo-ipv4/crear',
    grupoIpv4Editar: 'grupo-ipv4/editar/:id',
    grupoIpv4Nav: '/configuracion-red/grupo-ipv4',

    ///* Ipv4
    ipv4Nav: '/configuracion-red/ipv4',
    ipv4CrearNav: '/configuracion-red/ipv4/crear',
    ipv4Editar: '/configuracion-red/ipv4/editar/:id',
    ipv4EditarNav: '/configuracion-red/ipv4/editar',

    ///* Grupos IPV6 ------
    grupoIpv6: 'grupo-ipv6',
    grupoIpv6Crear: 'grupo-ipv6/crear',
    grupoIpv6Editar: 'grupo-ipv6/editar/:id',
    grupoIpv6Nav: '/configuracion-red/grupo-ipv6',

    ///* OLTs ------
    olt: 'olt',
    oltCrear: 'olt/crear',
    oltEditar: 'olt/editar/:id',
    oltNav: '/configuracion-red/olt',
    ///* Nodo ----------
    nodo: 'nodo',
    nodoCrear: 'nodo/crear',
    nodoEditar: 'nodo/editar/:id',
    nodoNav: '/configuracion-red/nodo',
    ///* Caja Primaria ----------
    cajaPrimaria: 'caja-primaria',
    cajaPrimariaCrear: 'caja-primaria/crear',
    cajaPrimariaEditar: 'caja-primaria/editar/:id',
    cajaPrimariaNav: '/configuracion-red/caja-primaria',
    ///* Caja Secundaria - NAP ----------
    naps: 'naps',
    napsCrear: 'naps/crear',
    napsEditar: 'naps/editar/:id',
    napsNav: '/configuracion-red/naps',


    ///* Routers ------
    routers: 'routers',
    routersCrear: 'routers/crear',
    routersEditar: 'routers/editar/:id',
    routersNav: '/configuracion-red/routers',

    ///* Bras
    brasNav: '/configuracion-red/bras',
    brasCrearNav: '/configuracion-red/bras/crear',
    brasEditar: '/configuracion-red/bras/editar/:id',
    brasEditarNav: '/configuracion-red/bras/editar',

    ///* Radius
    radiusNav: '/configuracion-red/radius',
    radiusCrearNav: '/configuracion-red/radius/crear',
    radiusEditar: '/configuracion-red/radius/editar/:id',
    radiusEditarNav: '/configuracion-red/radius/editar',

    ///* Operadora
    operadoraNav: '/configuracion-red/operadora',
    operadoraCrearNav: '/configuracion-red/operadora/crear',
    operadoraEditar: '/configuracion-red/operadora/editar/:id',
    operadoraEditarNav: '/configuracion-red/operadora/editar',
    ///* Radius
    radiusMigracionesNav: '/configuracion-red/radius-migraciones',
    radiusMigracionesCrearNav: '/configuracion-red/radius-migraciones/crear',
    radiusMigracionesEditar: '/configuracion-red/radius-migraciones/editar/:id',
    radiusMigracionesEditarNav: '/configuracion-red/radius-migraciones/editar',

    ///* Service Profile
    serviceProfileNav: '/configuracion-red/service-profile',
    serviceProfileCrearNav: '/configuracion-red/service-profile/crear',
    serviceProfileEditar: '/configuracion-red/service-profile/editar/:id',
    serviceProfileEditarNav: '/configuracion-red/service-profile/editar',
  },
  //inventario
  inventario: {
    root: 'inventario',
    productosNav: '/inventario/productos',
    productosCrearNav: '/inventario/productos/crear',
    productosEditarNav: '/inventario/productos/editar/',
    productosEditarIdNav: '/inventario/productos/editar/:idproducto',
    ingresoInventario: '/inventario/ingreso-inventario/',
    ingresoHistorial: '/inventario/ingreso-historial/',
    solicitudInventarioNav: '/inventario/ingreso-solicitud/',
    solicitudInventarioCrearNav: '/inventario/crear-solicitud/',
    revisarSolicitudInventarioNav: '/inventario/revision-solicitud/',
    revisarSolicitudInventarioCrearNav:
      '/inventario/revision-solicitud/:idsolicitud',
    trasladoInventario: '/inventario/traslado-inventario/',
    trasladoInventarioCrearNav: '/inventario/traslado-inventario/crear/',
    trasladoInventarioEditNav: '/inventario/traslado-inventario/edit',
    trasladoInventarioEdit: '/inventario/traslado-inventario/edit/:id',
    trasladoInventarioAccionNav: '/inventario/traslado-inventario/ingreso/:idtraslado',
    trasladoInventarioSolicitudEgresoNav: '/inventario/traslado-inventario/egreso/:id_solicitudegreso',
    trasladoInventarioIngresoNav: '/inventario/traslado-inventario/ingreso',
    trasladoInventarioCreateNotificacionNav: '/inventario/traslado-inventario/notificacion/:id',
    trasladoInventarioCreateNotificacion: '/inventario/traslado-inventario/notificacion',
    //
    transferenciaInventarioSolicitudEgresoNav: '/inventario/transferencia-inventario/egreso/:id_solicitudegreso',
    //trasladoInventarioIngreso:'/inventario/traslado-inventario/ingreso/:id_solicitudegreso',
    kardexNav: '/inventario/kardex/',
    modelo_productos: 'modelo-productos',
    modelo_productos_crear: 'modelo-productos/crear',
    modelo_productos_editar: 'modelo-productos/editar/:id',
    modelo_productos_nav: '/inventario/modelo-productos',
    categoria_productos: 'categoria-productos',
    categoria_productos_crear: 'categoria-productos/crear',
    categoria_productos_editar: 'categoria-productos/editar/:id',
    categoria_productos_nav: '/inventario/categoria-productos',
    subcategoria_productos: 'subcategoria-productos',
    subcategoria_productos_crear: 'subcategoria-productos/crear',
    subcategoria_productos_editar: 'subcategoria-productos/editar/:id',
    subcategoria_productos_nav: '/inventario/subcategoria-productos',
    marca_productos: 'marca-productos',
    marca_productos_crear: 'marca-productos/crear',
    marca_productos_editar: 'marca-productos/editar/:id',
    marca_productos_nav: '/inventario/marca-productos',
    ubicacion: 'ubicaciones',
    ubicacion_crear: 'ubicaciones/crear',
    ubicacion_editar: 'ubicaciones/editar/:id',
    ubicacion_nav: '/inventario/ubicaciones',
    bodegas: 'bodegas',
    bodegas_crear: 'bodegas/crear',
    bodegas_editar: 'bodegas/editar/:id',
    bodegas_nav: '/inventario/bodegas',
    //solicitud compra
    solicitud_compras: 'solicitudes-compras',
    solicitud_compras_editar: 'solicitudes-compras/editar/:id',
    solicitud_compras_crear: 'solicitudes-compras/crear',
    solicitud_compras_nav: '/inventario/solicitud-compras',
    //solicitud pedido
    solicitud_pedido: 'solicitudes-pedidos-usuarios',
    solicitud_pedido_nav: '/inventario/solicitudes-pedidos-usuarios',
    solicitud_all_action: 'solicitudes-all-actions',
    solicitud_all_action_nav: '/inventario/solicitudes-all-actions',
    solicitud_pedido_revision_nav: '/inventario/solicitud_pedido_revision/:id',
    //gastos
    gastos: 'gastos',
    gastos_crear: 'gastos/crear',
    gastos_editar: 'gastos/editar/:id',
    gastos_nav: '/inventario/gastos',
    //egresos
    egresos: 'egresos',
    egresos_crear: 'egresos/crear',
    egresos_editar: 'egresos/editar/:id',
    egresos_nav: '/inventario/egresos',
    egresos_action_nav: '/inventario/egresos/crear/:id_solicitudegreso', //TODO: comentar

    //costos
    costos: 'costos',
    costos_crear: 'costos/crear',
    costos_editar: 'costos/editar/:id',
    costos_nav: '/inventario/costos',
    //presentacion
    presentacion: 'presentacion',
    presentacion_crear: 'presentacion/crear',
    presentacion_editar: 'presentacion/editar/:id',
    presentacion_nav: '/inventario/presentacion',
    //medidas-productos
    medidas_productos: 'medidas-productos',
    medidas_productos_crear: 'medidas-productos/crear',
    medidas_productos_editar: 'medidas-productos/editar/:id',
    medidas_productos_nav: '/inventario/medidas-productos',
    // generador series
    generador_series: '/inventario/generador-series',
    // configuracion de transito
    configuracion_transito: '/inventario/configuracion-transito',

    //solicitud-ingreso-inventario
    solicitud_ingreso_inventario: 'solicitud-ingreso-inventario',
    solicitud_ingreso_inventario_nav: '/inventario/solicitud-ingreso-inventario',
    //orden-jefe-compra
    orden_jefe_compra: 'orden-jefe-compra',
    orden_jefe_compra_crear: 'orden-jefe-compra/crear',
    orden_jefe_compra_nav: '/inventario/orden-jefe-compra',
    ///inventario/solicitudes-ingresos-bodega
    solicitud_ingreso_bodega: 'solicitud-ingreso-bodega',
    solicitud_ingreso_bodega_crear: 'solicitud-ingreso-bodega/crear',
    solicitud_ingreso_bodega_nav: '/inventario/solicitud-ingreso-bodega',
    //Stock de materiales
    inventario_stock_materiales: '/inventario/stock-materiales',
    // solicitud de ingreso
    solicitud_ingreso_compra: 'solicitud-ingreso_compra',
    solicitud_ingreso_compraCrear: 'solicitud_ingreso_compra/crear',
    solicitud_ingreso_compraEditar: 'solicitud_ingreso_compra/editar/:id',
    solicitud_ingreso_compraNav: '/inventario/solicitud_ingreso_compra',
    solicitud_ingreso_compraNav_por_pedido: '/inventario/solicitud_ingreso_compra_por_pedido',

    ////recepcion

    recepcionCompraNav: '/inventario/recepcion-compra',
    recepcionCompraCrear: '/inventario/recepcion-compra/crear/:id',

    ///* Kit inventario
    kitInventariable: '/inventario/kit/',
    kitInventariableCreateNav: '/inventario/kit/crear',
    kitInventariableEditNav: '/inventario/kit/editar/:id',
    kitInventariableEdit: '/inventario/kit/editar',

    ///* reporte
    inventarioReporteStockNav: '/inventario/reporte-stock',

    solicitudFactibilidadCorporativoNav: '/inventario/solicitud-factibilidad',
    revisarSolicitudFactibilidadCorporativoNav: '/inventario/revisar/solicitud-factibilidad',
    revisarSolicitudFactibilidadCorporativo: '/inventario/revisar/solicitud-factibilidad/:id',

    ///* Revision de transferencia de inventario
    recepcionTransferenciaInventarioNav: '/inventario/recepcion/transferencia',
    recepcionEditTransferenciaInventarioNav: '/inventario/recepcion/editar/transferencia',
    recepcionEditTransferenciaInventario: '/inventario/recepcion/editar/transferencia/:id',

    ///* toma fisica
    tomaFisicaHistorialNav: '/inventario/toma-fisica',
    tomaFisicaCrearNav: '/inventario/crear/toma-fisica',
    tomaFisicaEditar: '/inventario/editar/toma-fisica/:id',
    tomaFisicaEditarNav: '/inventario/editar/toma-fisica',

    ///* reporte de stock
    reporteStockNav: '/inventario/reporte-stock',

    ///* servicio
    servicio: '/inventario/servicio',
    servicioCreateNav: '/inventario/crear/servicio',
    servicioEditar: '/inventario/editar/servicio/:id',
    servicioEditareNav: '/inventario/editar/servicio',
    ///* cuadre inventario
    cuadreInventarioNav: '/inventario/cuadre',
    cuadreInventarioCrearNav: '/inventario/cuadre/crear',
    cuadreInventarioEditarNav: '/inventario/cuadre/editar',
    cuadreInventarioEditar: '/inventario/cuadre/editar/:id',
  },
  pedidos: {
    root: 'pedidos',
    solicitud_pedidos: 'solicitudes-pedidos',
    solicitud_pedidos_crear: 'solicitudes-pedidos/crear',
    solicitud_pedidos_editar: 'solicitudes-pedidos/editar/:id',
    solicitud_pedidos_nav: '/pedidos/solicitudes-pedidos',
  },
  compras: {
    root: 'compras',
    proveedores: 'proveedores',
    proveedores_crear: 'proveedores/crear',
    proveedores_editar: 'proveedores/editar/:id',
    proveedores_nav: '/compras/proveedores',
    /* compras: 'compras',
   compras_crear: 'compras/crear',
   compras_editar: 'compras/editar/:id',
   compras_nav: '/compras/compras', */
    tipo_compras: 'tipo-compras',
    tipo_compras_crear: 'tipo-compras/crear',
    tipo_compras_editar: 'tipo-compras/editar/:id',
    tipo_compras_nav: '/compras/tipo-compras',
    //orden compra
    orden_compras: 'orden-compras',
    orden_compras_crear: 'orden-compras/crear',
    orden_compras_editar: 'orden-compras/editar/:id',
    orden_compras_nav: '/compras/orden-compras',
    orden_compras_action_nav: '/compras/orden-compras/crear/:idSolicitudIngreso',
    orden_compras_finalizar_nav: '/compras/orden-compras/finalizar/:id',
    orden_compras_consulta_nav: '/compras/consulta/orden_compra',
    orden_compras_revision: '/compras/orden_compras/revision/:id',
    reporte_compra: '/compras/reporte-compras',
    ///Grupo-proveedores
    grupo_proveedores: 'grupo-proveedores',
    grupo_proveedores_crear: 'grupo-proveedores/crear',
    grupo_proveedores_editar: 'grupo-proveedores/editar/:id',
    grupo_proveedores_nav: '/compras/grupo-proveedores',
    servicios: 'servicios',
    servicios_crear: 'servicios/crear',
    servicios_editar: 'servicios/editar/:id',
    servicios_nav: '/compras/servicios',
    solicitud_compra_bodega: 'solicitudes-compra-bodega',
    solicitud_compra_bodega_crear: 'solicitudes-compra-bodega/crear',
    solicitud_compra_bodega_editar: 'solicitudes-compra-bodega/editar/:id',
    solicitud_compra_bodega_nav: '/compras/solicitudes-compra-bodega',
    localidad_proveedores: 'localidad-proveedores',
    localidad_proveedores_crear: 'localidad-proveedores/crear',
    localidad_proveedores_editar: 'localidad-proveedores/editar/:id',
    localidad_proveedores_nav: '/compras/localidad-proveedores',
    solicitud_pedidos: 'solicitudes-pedidos',
    solicitud_pedidos_crear: 'solicitudes-pedidos/crear',
    solicitud_pedidos_editar: 'solicitudes-pedidos/editar/:id',
    //solicitud_pedidos_nav: '/compras/solicitudes-pedidos',
    //solicitud-ingreso

    solicitud_ingreso: 'solicitud-ingreso',
    solicitud_ingreso_crear: 'solicitud-ingreso/crear',
    solicitud_ingreso_editar: 'solicitud-ingreso/editar/:id',
    solicitud_ingreso_nav1: '/compras/solicitud-ingreso',
    solicitud_ingreso_nav: '/compras/solicitud-ingreso',
    ////revision de solicitud-ingreso
    solicitud_ingreso_revision: 'revision-solicitud-compra',
    solicitud_ingreso_revision_nav: '/compras/revision-solicitud-compra',
    solicitud_ingreso_revision_editar: '/compras/revision-solicitud-compra/editar/:id',
    // retenciones
    retencion_compra: 'retencion-compra',
    retencion_compra_crear: 'retencion-compra/crear',
    retencion_compra_editar: 'retencion-compra/editar/:id',
    retencion_compra_nav: '/compras/retencion-compra',


  },
  activos: {
    root: 'activos',
    activos: 'activos',
    activos_crear: 'activos/crear',
    activos_editar: 'activos/editar/:id',
    activos_nav: '/activos/activos',
    grupo_activos: 'grupo-activos',
    grupo_activos_crear: 'grupo-activos/crear',
    grupo_activos_editar: 'grupo-activos/editar/:id',
    grupo_activos_nav: '/activos/grupo-activos',
    responsables: 'responsables',
    responsables_crear: 'responsables/crear',
    responsables_editar: 'responsables/editar/:id',
    responsables_nav: '/activos/responsables',
    mantenimiento: 'mantenimiento',
    mantenimiento_crear: 'mantenimiento/crear',
    mantenimiento_editar: 'mantenimiento/editar/:id',
    mantenimiento_nav: '/activos/mantenimiento',
    depreciacion: 'depreciacion',
    depreciacion_crear: 'depreciacion/crear',
    depreciacion_editar: 'depreciacion/editar/:id',
    depreciacion_nav: '/activos/depreciacion',
    asignaciones: 'asignaciones',
    asignaciones_crear: 'asignaciones/crear',
    asignaciones_editar: 'asignaciones/editar/:id',
    asignaciones_nav: '/activos/asignaciones',
  },
  nomina: {
    root: 'nomina',
    cargos: 'cargos',
    cargos_crear: 'cargos/crear',
    cargos_editar: 'cargos/editar/:id',
    cargos_nav: '/nomina/cargos',
    empleados: 'empleados',
    empleados_crear: 'empleados/crear',
    empleados_editar: 'empleados/editar/:id',
    empleados_nav: '/nomina/empleados',
  },

  /////* Soporte Técnico ----------------
  soporteTecnico: {
    root: 'soporte-tecnico',

    ///* Desbloqueo usuario - login ------
    desbloqueoUsuario: 'desbloqueo/usuario',
    desbloqueoUsuarioNav: '/soporte-tecnico/desbloqueo/usuario',
  },

  /////* Tickets ----------------
  ticketSoporteCliente: {
    root: 'tickets-soporte-cliente',

    nuevo_ticket: 'nuevo-ticket',
    nuevo_ticket_crear: 'nuevo-ticket/crear/:idcontrato',
    nuevo_ticket_editar: 'nuevo-ticket/revisar/:idcontrato/:idticket',
    nuevo_ticket_nav: '/tickets-soporte-cliente/nuevo-ticket',
    nuevo_ticket_nav_crear: '/tickets-soporte-cliente/nuevo-ticket/crear/:idcontrato',

    //
    categoria_incidente: 'categoria-incidente',
    categoria_incidente_crear: 'categoria-incidente/crear',
    categoria_incidente_editar: 'categoria-incidente/editar/:id',
    categoria_incidente_nav: '/tickets-soporte-cliente/categoria-incidente',

    subcategoria_incidente: 'subcategoria-incidente',
    subcategoria_incidente_crear: 'subcategoria-incidente/crear',
    subcategoria_incidente_editar: 'subcategoria-incidente/editar/:id',
    subcategoria_incidente_nav: '/tickets-soporte-cliente/subcategoria-incidente',

    causal_incidente: 'causal-incidente',
    causal_incidente_crear: 'causal-incidente/crear',
    causal_incidente_editar: 'causal-incidente/editar/:id',
    causal_incidente_nav: '/tickets-soporte-cliente/causal-incidente',

    mis_tickets: 'mis-tickets',
    mis_tickets_crear: 'mis-tickets/crear',
    mis_tickets_editar: 'mis-tickets/editar/:id',
    mis_tickets_nav: '/tickets-soporte-cliente/mis-tickets',

    ticket: 'ticket',
    ticket_crear: 'ticket/crear',
    ticket_editar: 'ticket/editar/:id',
    ticket_nav: '/tickets-soporte-cliente/ticket',

    // Detalle Ticket
    detalle_ticket: 'detalle-ticket/:ticketId',
    detalle_ticket_nav: '/tickets-soporte-cliente/detalle-ticket',

    // Editar Ticket
    editar_ticket: 'editar-ticket/:ticketId',
    editar_ticket_nav: '/tickets-soporte-cliente/editar-ticket',

    // Perfil Cliente
    perfil_cliente: 'perfil-cliente/:clienteId',
    perfil_cliente_nav: '/tickets-soporte-cliente/perfil-cliente',

    // Masivos
    masivos: 'masivos',
    masivos_nav: '/tickets-soporte-cliente/masivos',
    masivos_crear: 'masivos/crear',
    masivos_crear_nav: '/tickets-soporte-cliente/masivos/crear',
    masivo_detalle: 'masivos/:masivoId',
    masivo_detalle_nav: '/tickets-soporte-cliente/masivos',

    // Agenda Tecnicos
    agenda: 'agenda',
    agenda_nav: '/tickets-soporte-cliente/agenda',

    // Catalogos
    catalogos: 'catalogos',
    catalogos_nav: '/tickets-soporte-cliente/catalogos',

    // Migracion Softnet
    migracion_softnet: 'migracion-softnet',
    migracion_softnet_nav: '/tickets-soporte-cliente/migracion-softnet',

    // Dashboard Supervisor (gated por permiso tickets.ver_dashboard_supervisor)
    dashboard: 'dashboard',
    dashboard_nav: '/tickets-soporte-cliente/dashboard',

    // Gestion de Accesos (legacy redirect - usa administration.gestionAccesosNav)
    gestion_accesos: 'gestion-accesos',
    gestion_accesos_nav: '/parametrizacion/gestion-accesos',

    // Tickets Internos
    tickets_internos: 'tickets-internos',
    tickets_internos_nav: '/tickets-soporte-cliente/tickets-internos',
  },
  ////*
  visitas: {
    root: 'visitas',

    ticket: 'ticket',
    ticket_crear: 'ticket/crear',
    ticket_editar: 'ticket/editar/:id',
    ticket_nav: '/visitas/ticket',
    ///agenda vista diaria
    agenda_diaria: 'agenda-diaria',
    agenda_diaria_crear: 'agenda-diaria/crear',
    agenda_diaria_editar: 'agenda-diaria/editar/:id',
    agenda_diaria_nav: '/visitas/agenda-diaria',
  },
  /////* Clientes ----------------
  clientes: {
    root: 'clientes',

    // Cliente contrato
    clienteContratoNav: '/clientes/contrato',

    // Cliente Actualizar
    actualizarDataCliente: 'contrato/actualizar/:id',

    // Fibra Optica ------
    fibraOptica: 'fibra-optica',
    fibraOpticaNav: '/clientes/fibra-optica',
    fibraOpticaView: 'fibra-optica/ver/:id',

    // Wireless ------
    wireless: 'wireless',
    wirelessNav: '/clientes/wireless',
    wirelessView: 'wireless/ver/:id',

    // Corporativo ------
    corporativo: 'corporativo',
    corporativoNav: '/clientes/corporativo',
    corporativoView: 'corporativo/ver/:id',

    ips: 'ips',
    ipsNav: '/clientes/ips',

    // Pymes
    clientesPymesNav: '/clientes/pymes',
    solicitudContratoPymesNav: '/clientes/pymes/contrato',
    solicitudContratoPymes: '/clientes/pymes/contrato/:id',

    // bras
    clientesBrasNav: '/clientes/bras',
  },

  tiketUser: {
    root: 'tikets',
    tikets_usuarios: 'usuarios-tikets',
    tikets_usuarios_nav: '/tikets/usuarios-tikets',
    ver_tikets_usuarios: 'usuarios-tikets/ver',
    ver_tikets_usuarios_nav: '/tikets/usuarios-tikets/ver',
    tikets_usuarios_crear: 'usuarios-tikets/ver/crear',
  },
  //** MARTKETING
  marketing: {
    root: 'marketing',

    solicitudesCanjeEvento: '/marketing',

    solicitudesCanjeEventoNav: '/marketing/solicitud-canje-evento',
    solicitudesCanjeEventoCrearNav: '/marketing/solicitud-canje-evento/crear',
    solicitudesCanjeEventoEditarNav: '/marketing/solicitud-canje-evento/editar',
    solicitudesCanjeEditar: '/marketing/solicitud-canje/editar/:idsolicitud',
    solicitudesCanjeEditarNav: '/marketing/solicitud-canje/editar',
    solicitudesEventoEditar: '/marketing/solicitud-evento/editar/:idsolicitud',
    solicitudesEventoEditarNav: '/marketing/solicitud-evento/editar',

    revisarSolicitudesCanjeEventoNav: '/marketing/revision-canje-evento',

    solucionSolicitudesCanjeEventoNav: '/marketing/solucion-canje-evento',
    solucionSolicitudesCanjeEventoEdit: '/marketing/solucion-canje-evento/:idsolicitudespendientes',

  },
  // delete
  del: {
    noRoute: 'no-route',
  },


  solucionesDigitales: {
    root: 'soluciones-digitales',

    servicios: 'servicios',
    servicios_crear: 'servicios/crear',
    servicios_crear_nav: '/soluciones-digitales/servicios/crear',
    servicios_editar: 'servicios/editar/:id',
    servicios_editar_nav: '/soluciones-digitales/servicios/editar/:id',
    servicios_nav: '/soluciones-digitales/servicios',
  },
};
